<!-- eslint-disable -->
<template>
  <div id="area">
    <Grid
      ref="grid"
      :style="{ height: '300px' }"
      :data-items="filteredData"
      :selected-field="selectedField"
      :columns="columns"
      :filterable="true"
      :filter="filter"
      :sortable="true"
      :sort="sort"
      @filterchange="filterChange"
      @selectionchange="onSelectionChange"
      @headerselectionchange="onHeaderSelectionChange"
      @rowclick="onRowClick"
      @sortchange="sortChange"
      :filter-cell-render="filterRender"
    >
      <template v-slot:filterSlotTemplate="{ props, methods }">
        <div>
          <input
            type="text"
            :value="props.value"
            @input="
              (ev) => {
                props.onChange({
                  operator: 'contains',
                  field: props.field,
                  value: ev.target.value,
                  syntheticEvent: ev,
                });
              }
            "
            style="width: 180px"
          />
          <button
            @click="
              (ev) => {
                props.onChange({
                  operator: '',
                  field: '',
                  value: '',
                  event: ev,
                });
              }
            "
          >
            Clear
          </button>
        </div>
      </template>
      >
    </Grid>
  </div>
</template>

<script>
import { Grid } from "@progress/kendo-vue-grid";
import "@progress/kendo-theme-default/dist/all.css";
import { filterBy, orderBy } from "@progress/kendo-data-query";
import { apiPost } from "@/services/api/fetchapi";
import { UserStore} from "@/store/modules/userstore"

export default {
  name: "Area",
  components: {
    Grid: Grid,
  },
  data: function () {
    return {
      filter: {},
      //     logic: "and",
      //     filters: [
      //         { field: "UnitPrice", operator: "neq", value: 2 }
      //     ]
      // },
      sort: [{ field: "nameBereich", dir: "asc" }],
      selectedField: "selected",
      filteredData: [],
      originData: [],
      staticColumns: [
        {
          field: "idBereich",
          title: "IdBereich",
          filterable: false,
          sortable: false,
          hidden: true,
        },
        {
          field: "fkMandant",
          title: "fkMandant",
          filterable: false,
          sortable: false,
          hidden: true,
        },
        {
          field: "nameBereich",
          title: "NameBereich",
          filterCell: "filterSlotTemplate",
          width: "350px",
        },
        {
          field: "istAlarmZuVerriegeln",
          title: "zu Verriegeln",
          filterable: false,
          width: "100px",
        },
        {
          field: "istAlarmVerriegelt",
          title: "Verriegelt",
          filterable: false,
          width: "100px",
        },
        {
          field: "istKeinEreignisZuErzeugen",
          title: "kein Ereignis",
          filterable: false,
          width: "150px",
          hidden: true,
        },
        {
          field: "ereignisStatusCode",
          title: "Ereignis-Status",
          width: "300px",
          hidden: true,
        },
        {
          field: "letzteVerriegelung",
          title: "letze Verriegelung",
          width: "200px",
        },
      ],
    };
  },
  computed: {
    areAllSelected() {
      return (
        this.filteredData.findIndex((item) => item.selected === false) === -1
      );
    },
    columns() {
      return [
        {
          field: "selected",
          width: "50px",
          filterable: false,
          headerSelectionValue: this.areAllSelected,
        },
        ...this.staticColumns,
      ];
    },
  },
  created() {
    this.getData();
  },
  methods: {
    onHeaderSelectionChange(event) {
      let checked = event.event.target.checked;
      this.filteredData = this.filteredData.map((item) => {
        return { ...item, selected: checked };
      });
      const areaInfo = this.$store.getters["areastore/getDataSet"];
      areaInfo.areas = []
      areaInfo.areas.splice(0, areaInfo.areas.length);
      this.filteredData.forEach((item) => {
        if (item.selected === true) {
          areaInfo.areas.push(item);
        }
      });

      this.$store.commit("areastore/addDataSet", areaInfo)
    },
    onSelectionChange(event) {
      this.selectionChanged(event)
    },
    selectionChanged( event ) {
      event.dataItem[this.selectedField] = !event.dataItem[this.selectedField];
      const areaInfo = this.$store.getters["areastore/getDataSet"];
      //areaInfo.areas.splice(0, areaInfo.areas.length);
      areaInfo.areas = []
      this.filteredData.forEach((item) => {
        if (item.selected === true) {
          areaInfo.areas.push(item);
        }
      });

      this.$store.commit("areastore/addDataSet", areaInfo)
    },
    onRowClick(event) {
      this.selectionChanged(event)
    },
    filterChange: function (ev) {
      this.filter = ev.filter;
      this.filteredData = filterBy(this.originData, this.filter)
    },
    filterRender: function (h, defaultRendering, props, change) {
      return defaultRendering;
    },
    sortChange: function (e) {
      this.sort = e.sort;
      this.filteredData = orderBy(this.originData, this.sort)
    },
    async getData() {
      const temp = await apiPost("ComponentView/viewKomponenteBereich", {
      userId: this.$store.getters["userstore/getUser"]
      });
      this.filteredData = temp.map((item) => {
        return { ...item, selected: false };
      });
      this.originData = temp.map((item) => {
        return { ...item, selected: false };
      });
    },
  },
};
</script>
